import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../public/img/desenvolvedor-front-end.webp'


const _hoisted_1 = { class: "column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-image" }, [
    /*#__PURE__*/_createElementVNode("figure", { class: "image is-4by3" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "Placeholder image"
      })
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}